import { makeStyles, type Theme } from '@material-ui/core';
import { Colors } from '@rentguru/commons-utils';

export const fieldFilterButtonStyles = makeStyles<Theme, { isReset: boolean }>((theme: Theme) => ({
  root: {
    margin: theme.spacing(1),
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    flexDirection: 'inherit',
    alignItems: 'center',
    alignContent: 'center',
    fontSize: '12px',
    lineHeight: '15px',
    color: Colors.BLUE_GREY,
    ...(props) => (props.isReset ? { fill: Colors.BLUE_GREY } : {}),

    '&:hover': {
      color: Colors.SILVER,
      ...(props) => (props.isReset ? { fill: Colors.SILVER } : {}),
    },
    '&:focus': {
      color: Colors.BLUE_GREY,
      ...(props) => (props.isReset ? { fill: Colors.BLUE_GREY } : {}),
    },
  },
  active: {
    color: Colors.BLUE_GREY,
    ...(props) => (props.isReset ? { fill: Colors.BLUE_GREY } : {}),

    '& $icon': {
      opacity: 1,
    },
  },
  icon: {
    height: 16,
    width: 16,
    marginRight: 4,
    marginLeft: 4,
    opacity: 0,
    transition: theme.transitions.create(['opacity', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    userSelect: 'none',
  },
}));
